/* eslint-disable */
const pubSub = { handlers: {} };

pubSub.off = function(eventType) {
  if (eventType) {
    delete this.handlers[eventType];
  } else {
    Object.keys(this.handlers).forEach(key => {
      delete this.handlers[key];
    });
  }
  return this;
};

pubSub.on = function(eventType, handler) {
  if (!(eventType in this.handlers)) {
    this.handlers[eventType] = [];
  }
  this.handlers[eventType].push(handler);
  return this;
};

pubSub.emit = function(...args) {
  if (!this.handlers[args[0]]) return;
  this.handlers[args[0]].forEach(handler => {
    const cloneArgs = [...args];
    cloneArgs.shift();
    handler.apply(this, cloneArgs);
  });
  return this;
};

export { pubSub };

export default {};
